// extracted by mini-css-extract-plugin
export default {"root":"SearchBar_root__ATZmp","collapsed":"SearchBar_collapsed__APFBe"};